'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PollUtil = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _SmartColor = require('../models/SmartColor');

var _SmartColor2 = _interopRequireDefault(_SmartColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable import/prefer-default-export */


var smartColor = new _SmartColor2.default();

var PollUtil = exports.PollUtil = function PollUtil() {
  _classCallCheck(this, PollUtil);
};

PollUtil.generatePollChartData = function (poll) {
  var submissions = poll.submissions,
      answers = poll.answers,
      answersPercentage = poll.answersPercentage;


  var count = 0;
  var pctg = 0;

  var res = Object.values(answers).map(function (answer, i) {
    // in some cases, the percentages are already calculated
    if (answersPercentage) {
      if (answersPercentage[answer.id]) {
        pctg = parseFloat(answersPercentage[answer.id].replace('%', ''), 10);
      }
    } else {
      count = !(0, _lodash.isEmpty)(submissions) && submissions.filter(function (item) {
        return item === answer.id;
      }).length;
      pctg = Math.round(((count / submissions.length || 0) * 100 + Number.EPSILON) * 100) / 100;
    }
    return _extends({}, answer, {
      submissionCount: submissions && submissions.length || 0,
      submissionPercentage: pctg,
      color: smartColor.getSmartColor(i + 1)
    });
  });
  return res;
};

PollUtil.getPollChartOptions = function (data) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var chart = opts.chart,
      title = opts.title,
      tooltip = opts.tooltip,
      _opts$plotOptions = opts.plotOptions,
      plotOptions = _opts$plotOptions === undefined ? {} : _opts$plotOptions,
      _opts$plotOptions2 = opts.plotOptions;
  _opts$plotOptions2 = _opts$plotOptions2 === undefined ? {} : _opts$plotOptions2;
  var pie = _opts$plotOptions2.pie,
      _opts$point = opts.point,
      point = _opts$point === undefined ? {} : _opts$point,
      accessibility = opts.accessibility,
      series = opts.series,
      credits = opts.credits;


  return {
    chart: _extends({
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie'
    }, chart),
    title: _extends({
      text: null
    }, title),
    tooltip: _extends({
      pointFormat: '{series.name}: <b>{point.y}%</b>'
    }, tooltip),
    accessibility: _extends({
      point: _extends({
        valueSuffix: '%'
      }, point)
    }, accessibility),
    plotOptions: _extends({
      pie: _extends({
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        }
      }, pie)
    }, plotOptions),
    series: [_extends({
      name: 'Answers',
      colorByPoint: true,
      data: data
    }, series)],
    credits: _extends({
      enabled: false
    }, credits)
  };
};